// extracted by mini-css-extract-plugin
export default {"status-toggle":"heartbeat-toggle_status-toggle__f5q6E"};